import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

import { IntegrationTokenJwtResponse } from '@models/swagger';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  getTokenPayload(jwtToken: string): IntegrationTokenJwtResponse {
    try {
      const decoded: { customPayload: IntegrationTokenJwtResponse } = jwtDecode(jwtToken);
      return decoded.customPayload;
    } catch (err) {
      console.error(err);
      return err;
    }
  }
}
